import { useEffect, useState } from "react";

const STYLE = {
  width: "100%",
  height: "100%",
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  margin: "0 auto",
} as const;

const ErrorBoundaryHandler = () => {
  const [seconds, setSeconds] = useState<number>(60);

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout> | null = null;
    if (seconds === 0) {
      if (globalThis.location.pathname === "/") {
        globalThis.location.reload();
      } else {
        globalThis.location.href = "/";
      }
    } else {
      timeout = setTimeout(() => {
        setSeconds(seconds - 1);
      }, 1000);
    }
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [seconds]);

  return (
    <div style={STYLE}>
      <div>There was an issue loading the page.</div>
      <div className="mt-2">Resetting and reloading BellaRates in {seconds} seconds.</div>
    </div>
  );
};

export default ErrorBoundaryHandler;
